import DairyOneSpa from '../../../core/web/js/DairyOneSpa';
import menuData from '../json/menu.json';

import '../css/stargrave.css';

//state
import CrewState from './state/CrewState';
import PowersState from './state/PowersState';
import SoldiersState from './state/SoldiersState';
import SoldierState from './state/SoldierState';
import ItemsState from './state/ItemsState';
import BestiaryState from './state/BestiaryState';
import RandomEncountersState from './state/RandomEncountersState';
import CaptainState from './state/CaptainState';
import FirstMateState from './state/FirstMateState';

//pages
import Home from './content/Home';
import Crew from './content/Crew';
import Powers from './content/Powers';
import Soldiers from './content/Soldiers';
import Soldier from './content/Soldier';
import Items from './content/Items';
import Bestiary from './content/Bestiary';
import RandomEncounters from './content/RandomEncounters';
import Captain from './content/levelCharacter/Captain';
import FirstMate from './content/levelCharacter/FirstMate';

const pages ={
  "home":{"component":Home},
  "crew":{"component":Crew, "state": CrewState},
  "powers":{"component":Powers, "state": PowersState},
  "soldiers":{"component":Soldiers, "state": SoldiersState},
  "soldier":{"component":Soldier, "state": SoldierState},
  "items":{"component":Items, "state": ItemsState},
  "bestiary":{"component":Bestiary, "state": BestiaryState},
  "randomencounters":{"component":RandomEncounters, "state": RandomEncountersState},
  "captain":{"component":Captain, "state": CaptainState},
  "firstmate":{"component":FirstMate, "state": FirstMateState},
};

/**
 * Stargrave Core framework application.
 * @author James Adams
 * @param {object} props
 * @returns {jsx}
 * @public
 */
function Stargrave(props){
  return (
    <div className="stargrave">
    <DairyOneSpa
      title={'StarGrave'}
      menuData={menuData}
      pages={pages}
      page={'crew'}
    >
    <div className="twinkling"></div>
    </DairyOneSpa>
    </div>
  );
}

export default Stargrave;
